<template>
  <v-container fluid class="bookings">
    <v-card flat>
      <v-card-title>
        <v-btn text small @click="$router.back()">
          <v-icon left> mdi-arrow-left </v-icon>
          Back
        </v-btn>
        <v-spacer />
        <div class="ma-2">
          <v-btn
            :to="{
              name: 'BookedUnitReceipt',
              params: { code: postedReceiptNumber },
            }"
            v-if="!canPay"
            color="primary"
          >
            <v-icon size="" class="mr-2">receipt_long</v-icon>
            Receipt
          </v-btn>
        </div>
        <div class="ma-2">
          <v-btn
            v-if="programme && canPay"
            class="error"
            :to="{
              name: 'ExamBookingPayments',
              params: { code: base64Param },
            }"
          >
            <v-icon class="mr-2">mdi-cash</v-icon>Pay
          </v-btn>
        </div>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-data-table
          :items-per-page="5"
          :headers="headers"
          :items="studentBookings"
        >
          <template v-slot:[`item.ID`]="{ index }">
            <span>{{ index + 1 }}</span>
          </template>
          <template v-slot:[`item.examCenter`]="{ item }">
            <span v-bind:key="index" v-for="(center, index) of examCenters">
              <span v-if="item['examCenter'] === center['Code']">{{
                center["Name"]
              }}</span>
            </span>
          </template>
          <template v-slot:[`item.examDate`]="{ item }">
            <span>{{ formatDate(item.examDate) }}</span>
          </template>
          <template v-slot:[`item.startTime`]="{ item }">
            <span>{{ formatTime(item.startTime) }}</span>
          </template>
          <template v-slot:[`item.endTime`]="{ item }">
            <span>{{ formatTime(item.endTime) }}</span>
          </template>
          <template v-slot:[`item.postedReceiptNo`]="{ item }">
            <span
              ><v-icon
                size="12"
                :color="
                  item.postedReceiptNo.length === 0
                    ? 'deep-orange darken-1'
                    : 'primary'
                "
                >mdi-radiobox-marked</v-icon
              >
              {{
                `${item.postedReceiptNo.length === 0 ? "Not Paid" : "Booked"}`
              }}</span
            >
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-menu open-on-hover>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="text-capitalize links"
                  text
                  v-bind="attrs"
                  v-on="on"
                  small
                  ><v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  @click="removeItem(item)"
                  v-if="item.postedReceiptNo.length === 0"
                >
                  <v-icon color="error" size="">mdi-delete</v-icon>
                  Remove
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import examMixins from "@/packages/exams/examMixins";
import { helper } from "@/packages/dashboard/utils";

export default {
  name: "examBookingList",
  mixins: [examMixins],
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Exam/studentRegistrations");
    });
  },
  data: () => ({
    routeParameter: "",
    headers: [
      { text: "#S/N", value: "ID" },
      { text: "Unit Code", value: "unit" },
      { text: "Paper", value: "paper" },
      { text: "Venue", value: "examCenter" },
      { text: "Date", value: "examDate" },
      { text: "Start Time", value: "startTime" },
      { text: "End Time", value: "endTime" },
      { text: "Status", value: "postedReceiptNo" },
      { text: "Actions", value: "action" },
    ],
  }),
  mounted() {
    this.routeParameter = helper.decrypt(this.$route.params.code);
  },
  computed: {
    canPay() {
      return this.studentBookings
        ? this.studentBookings.filter(
            (item) => item["postedReceiptNo"].length === 0,
          ).length !== 0
        : false;
    },
    programme() {
      return this.$store.getters["Exam/studentExamGetter"](
        "studentRegistrations",
      )
        .filter((item) => item["transactionID"] === this.routeParameter)
        .shift();
    },
    base64Param() {
      return this.programme === null
        ? ""
        : helper.encrypt(this.programme["transactionID"]);
    },
    examCenters() {
      return this.$store.getters["Exam/studentExamGetter"]("examCenters");
    },
    studentBookings() {
      if (this.programme) {
        return this.programme["studentunits"].filter((item) => item["taken"]);
      }
      return [];
    },
    postedReceiptNumber() {
      return this.studentBookings
        ? this.studentBookings[0]["postedReceiptNo"]
        : "";
    },
  },
  methods: {
    formatDate(date) {
      return helper.getDateFormat(date);
    },
    formatTime(time) {
      return helper.getTimeFormat(time);
    },
    removeItem(item) {
      if (item["taken"]) {
        let examBooking = {
          transactionID: this.programme["transactionID"],
          examCenter: this.programme.examCenter,
          units: [
            {
              unit: item["unit"],
              taken: false,
              examCenter: this.programme.examCenter,
            },
          ],
        };
        this.$store.dispatch("Exam/removeBooking", { ...examBooking });
        this.$store.dispatch("Exam/studentRegistrations");
      }
    },
  },
};
</script>
<style scoped>
.bookings {
  font-family: "PT Sans Caption", sans-serif;
}
</style>
